<template>
	<transition-fade mode="out">
		<div
			v-show="showSplash"
			class="splash-page"
		>
			<div ref="overlay" class="splash-page__overlay">
				<logo ref="logo" />
			</div>
			<div ref="lines1" class="splash-page__lines splash-page__lines--group1">
				<span />
				<span />
				<span />
				<span />
			</div>
			<div ref="lines2" class="splash-page__lines splash-page__lines--group2">
				<span />
				<span />
				<span />
				<span />
			</div>
			<div ref="backgroundWrap" class="splash-page__background-wrap">
				<img ref="background1" class="splash-page__background splash-page__background--1" src="@/assets/splash-page_background1.jpg" />
				<img ref="background2" class="splash-page__background splash-page__background--2" src="@/assets/splash-page_background2.jpg" />
			</div>
			<div ref="pocket" class="splash-page__pocket">
				<img src="@/assets/splash-page_pocket1.jpg" />
			</div>
		</div>
	</transition-fade>
</template>

<script>
import { TweenMax, TimelineMax } from 'gsap';
import Logo from '@/components/logo.vue';
import TransitionFade from '@/components/transition-fade.vue';

export default {
	components: {
		Logo,
		TransitionFade,
	},
	data() {
		return {
			showSplash: false,
			timeline: new TimelineMax( {
				onComplete: this.handleAnimationComplete,
			} ),
		};
	},
	mounted() {
		const { introFinished } = window.sessionStorage;
		if ( introFinished ) {
			return;
		}
		this.showSplash = true;
		this.logoSetup();
		this.splashAnimate();
	},
	methods: {
		splashAnimate() {
			const logo = this.$refs.logo.$el;
			const overlay = this.$refs.overlay;
			const backgroundWrap = this.$refs.backgroundWrap;
			const background1 = this.$refs.background1;
			const background2 = this.$refs.background2;
			const lines1 = [].slice.call( this.$refs.lines1.children );
			const lines2 = [].slice.call( this.$refs.lines2.children );
			const pocket = this.$refs.pocket;

			TweenMax.to( background1, 8, {
				scale: 1.3,
				delay: 0.8,
			} );

			// Step 1
			this.timeline.add(
				TweenMax.to( logo, 1, {
					opacity: 1,
					scale: 2.5,
					delay: 0.6,
					ease: 'back.out(2.3)',
				} ) );

			// Step 2
			this.timeline.add( [
				TweenMax.to( overlay, 1.2, {
					backgroundColor: 'rgba(0, 0, 0, 0)',
					ease: 'power2.in',
					delay: -1,
				} ),
			] );

			// Step 3
			this.timeline.add( [
				TweenMax.to( background2, 1.8, {
					opacity: 0.8,
					ease: 'power2.in',
					delay: -0.8,
				} ),
			] );

			// Step 4
			this.timeline.add( [
				// TweenMax.to( backgroundWrap, 0.3, {
				// 	clipPath: 'polygon(0 0, 65% 0, 100% 100%, 0% 100%)',
				// 	delay: 0,
				// } ),
				TweenMax.to( backgroundWrap, 0.4, {
					clipPath: 'polygon(0 0, 65% 0, 85% 100%, 0% 100%)',
					// delay: 0.3,
				} ),
				TweenMax.to( lines1, 0.3, {
					height: '100%',
					delay: 0.4,
					ease: 'power2.in',
					stagger: 0.2,
				} ),
				TweenMax.set( lines1, {
					marginBottom: 0,
					marginTop: 'auto',
					delay: 2.2,
				} ),
				TweenMax.to( lines1, 0.2, {
					height: 0,
					delay: 2.2,
					ease: 'power2.out',
					stagger: 0.1,
				} ),
				TweenMax.to( background2, 2.5, {
					opacity: 1,
					delay: 0.2,
				} ),
				TweenMax.to( pocket, 2.2, {
					scale: 1,
					delay: 0,
				} ),
				TweenMax.to( lines2, 0.3, {
					height: '100%',
					delay: 1.8,
					ease: 'power2.in',
					stagger: 0.2,
				} ),
			] );
		},
		logoSetup() {
			TweenMax.set( this.$refs.logo.$el, {
				opacity: 0,
			} );
		},
		handleAnimationComplete() {
			window.scrollTo( 0, 0 );
			sessionStorage.setItem( 'introFinished', true );
			this.showSplash = false;
		},
	},
};
</script>

<style>
.splash-page {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 20;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
}

.splash-page .logo {
	width: 162px;
	fill: #fff;
}

.splash-page__overlay {
	z-index: 3;
	top: 0;
	left: 0;
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 60px;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 1);
}

.splash-page__background-wrap {
	z-index: 1;
	clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
}

.splash-page__background-wrap,
.splash-page__background {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.splash-page__background {
	z-index: 1;
	object-fit: cover;
}

.splash-page__background--1 {
	z-index: 1;
}

.splash-page__background--2 {
	z-index: 2;
	opacity: 0;
}

.splash-page__pocket {
	z-index: 0;
	position: absolute;
	top: 0;
	right: 0;
	width: 40%;
	height: 100%;
	transform: scale(2);
}

.splash-page__pocket img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.splash-page__lines {
	z-index: 2;
	position: absolute;
	top: 0;
	display: flex;
	height: 150%;
	margin-top: -60px;
	transform: rotate(30deg);
}

.splash-page__lines--group1 {
	right: 0;
}

.splash-page__lines--group2 {
	left: 0;
	margin-top: -200px;
	margin-left: -200px;
}

.splash-page__lines span {
	display: block;
	height: 0;
	width: 30px;
	background-color: rgba(247, 82, 0, 0.4);
}

.splash-page__lines span + span {
	margin-left: 80px;
}
</style>
